const hasSource = (video) => [...video.querySelectorAll('source')].some((source) => source.src)

export const createVideoPlayback = (video) => {
  let playPromise = null
  let shouldPlay = false

  const startPlay = () => {
    if (!shouldPlay) {
      return
    }

    const promise = video.play()
    playPromise = promise

    promise.then(() => {
      if (!shouldPlay) {
        video.pause()
      }
    }).catch(() => {
      if (playPromise !== promise) {
        return
      }

      playPromise = null

      if (shouldPlay) {
        video.addEventListener('canplay', startPlay, { once: true })
      }
    })
  }

  const play = () => {
    shouldPlay = true
    video.removeEventListener('canplay', startPlay)

    if (!hasSource(video)) {
      video.addEventListener('loadstart', startPlay, { once: true })
      return
    }

    startPlay()
  }

  const pause = () => {
    shouldPlay = false
    video.removeEventListener('loadstart', startPlay)
    video.removeEventListener('canplay', startPlay)

    const pending = playPromise
    playPromise = null

    if (!pending) {
      video.pause()
      return
    }

    pending.then(() => {
      if (!shouldPlay) {
        video.pause()
      }
    }).catch(() => {})
  }

  return { play, pause }
}

export const observeVideoPlayback = (video) => {
  video.removeAttribute('autoplay')

  const { play, pause } = createVideoPlayback(video)

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.intersectionRatio === 1) {
      play()
    } else {
      pause()
    }
  }, { threshold: [0, 1] })

  observer.observe(video)
}
